import { View } from "react-native";
import { Bell, Briefcase, Building2 } from "@/components/icons/HugeIcons";
import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../hooks/useTheme";
import { useWorkspace } from "../../../providers/useWorkspace";
import { SectionCard, SectionHeader, SettingsRow } from "./shared-native";

export function JobPreferenceLinks() {
  const router = useRouter();
  const { theme } = useTheme();
  const { t } = useTranslation("seeker");
  const { companyId } = useWorkspace();
  const iconProps = { size: 20, color: theme.textSecondary, strokeWidth: 1.75 };

  return (
    <View>
      <SectionHeader title={t("jobMatching.jobPreferences")} />
      <SectionCard>
        <SettingsRow
          icon={<Briefcase {...iconProps} />}
          label={t("jobMatching.editSearch")}
          onPress={() => router.push("/job-preferences")}
          showChevron
        />
        <SettingsRow
          icon={<Bell {...iconProps} />}
          label={t("jobMatching.alerts")}
          onPress={() => router.push("/settings/job-alerts" as never)}
          showChevron
          isLast
        />
      </SectionCard>
      {!!companyId && (
        <>
          <SectionHeader title={t("jobMatching.employerPreferences")} />
          <SectionCard>
            <SettingsRow
              icon={<Building2 {...iconProps} />}
              label={t("jobMatching.companySettings")}
              onPress={() => router.push("/(employer)/company/settings" as never)}
              showChevron
              isLast
            />
          </SectionCard>
        </>
      )}
    </View>
  );
}
